/// <amd-module name="Wiki/Editor/Helpers" />
import { IVssPageContext } from "VSS/Platform/Context";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { IWikiEditorState } from "Wiki/Editor/Contracts";
import { WikiPageInfoWithName } from "Wiki/ViewCommon/Contracts";
import { isEdge, isFirefox } from "Wiki/ViewCommon/Utils/WikiHelper";

export function isDirty(pageInfo: WikiPageInfoWithName, editorState: IWikiEditorState): boolean {
    const untranslatedContent = editorState.legacyScripts.wikiAutoCompleteNwpWrapperModule.translateDisplayNamesToStorageKeysOfPersonMentions(
        editorState.pageContent || ""
    );
    return pageInfo.content !== untranslatedContent || editorState.pageName.trim() !== pageInfo.pageName;
}

export function isRename(pageInfo: WikiPageInfoWithName, editorState: IWikiEditorState): boolean {
    return !!pageInfo.pageName && editorState.pageName.trim() !== pageInfo.pageName;
}

export function isInsertTextSupported(pageContent: string | undefined): boolean {
    if (pageContent == undefined) {
        return false;
    }

    // ie does not support it and correctly reports that it does not support it.
    // firefox claims to support it... but lies.
    // see https://bugzilla.mozilla.org/show_bug.cgi?id=1220696
    // Edge doesn't support insertText if textArea element is empty.
    if (isFirefox() || !document.queryCommandSupported("insertText") || (isEdge() && pageContent === "")) {
        return false;
    }

    return true;
}

/**
 * Count bytes in a string's UTF-8 representation.
 * Calculation details link: https://en.wikipedia.org/wiki/UTF-8
 */
export function getPageTextSize(text: string): number {
    let byteLen = 0;
    for (let i = 0; i < text.length; i++) {
        const c = text.charCodeAt(i);
        byteLen += c < 2 ** 7 ? 1 : c < 2 ** 11 ? 2 : c < 2 ** 16 ? 3 : c < 2 ** 21 ? 4 : Number.NaN;
    }

    return isNaN(byteLen) ? 0 : byteLen;
}
